import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import Home from "../views/Home/Home";
import FAQs from "../views/FAQs/FAQs";
import Contact from "../views/Contact/Contact";

import "../styles/global.scss";

function AppRouter() {
  return (
    <Router>
      <div className="site">
        <Header />
        <main>
          <Routes>
            <Route path="/faqs" element={<FAQs />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/" element={<Home />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default AppRouter;
